/**
 * Keeps repeated UTC calendar date and schedule timestamp rendering consistent
 * while allowing each surface to retain its own unavailable-value fallback.
 */
import { DateTime } from 'luxon';

const UTC_DATE_FORMAT = 'M/d/yyyy';
const UTC_DATE_TIME_FORMAT = 'MMM dd, yyyy HH:mm';
const UTC_DATE_TIME_WITH_ZONE_FORMAT = "MMM dd, yyyy HH:mm 'UTC'";

function formatUtcValue (
  iso: string | undefined,
  format: string,
  fallback: string,
): string {
  if (!iso) return fallback;
  const dateTime = DateTime.fromISO(iso, { zone: 'utc' });
  return dateTime.isValid ? dateTime.toFormat(format) : fallback;
}

export function formatUtcDate (
  iso: string | undefined,
  fallback: string,
): string {
  return formatUtcValue(iso, UTC_DATE_FORMAT, fallback);
}

export function isUtcDateTimeExpired (iso: string | undefined): boolean {
  if (!iso) return false;
  const expiry = DateTime.fromISO(iso, { zone: 'utc' });

  return expiry.isValid && expiry.toMillis() <= DateTime.now().toUTC().toMillis();
}

export function formatUtcDateTime (
  iso: string | undefined,
  fallback: string,
): string {
  return formatUtcValue(iso, UTC_DATE_TIME_FORMAT, fallback);
}

export function formatUtcDateTimeWithZone (
  iso: string | undefined,
  fallback: string,
): string {
  return formatUtcValue(iso, UTC_DATE_TIME_WITH_ZONE_FORMAT, fallback);
}
